import { useFetch } from '@/hooks/useFetch'
import { buildQuery } from '@/lib/transform'

export type Brand = {
  id: number
  name: string
  menuHome: boolean
  active: boolean
}

interface UseBrandsQueries {
  search?: string
  size?: string
  pagination?: string
}

export function useBrands(queries: UseBrandsQueries = {}) {
  const { size = '', search = '', pagination = '' } = queries

  return useFetch<Brand[]>(
    `/api/proxy/catalog/pvt/admin/brand?${buildQuery(search, pagination, size)}`
  )
}
